<template>
  <div>
    <v-card>
      <v-card-title>
        <h1>Select Crew</h1>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selectedCrew"
          :headers="headers"
          :items="crew"
          :items-per-page="10"
          :loading="crewLoading"
          item-key="vesselCrewId"
          show-select
        ></v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import Objects from '@/services/Objects'

export default {
  name: 'VesselTrialCrewSelectTable',
  props: {
    id: String,
    trialSelectedCrew: Array
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Position', value: 'position' }
      ],
      crew: [],
      selectedCrew: [],
      unselectedCrew: [],
      loading: false,
      crewLoading: false
    }
  },
  created() {
    this.getCrew()
  },
  methods: {
    getCrew() {
      ApiService.get(Objects.VesselCrew + '/byvessel', this.id).then(
        response => {
          this.crew = response.data
          this.setCrew()
        }
      )
    },
    setCrew() {
      if (this.trialSelectedCrew && this.trialSelectedCrew.length > 0) {
        this.selectedCrew = [...this.trialSelectedCrew]
      }
    },
    getSelectedCrew() {
      return this.selectedCrew
    }
  }
}
</script>

<style scoped></style>
